import { Card, Tabs, Typography } from "antd";
import { useSearchParams } from "react-router-dom";

import { HelpArticlesTab } from "./HelpArticlesTab";
import { HELP_CENTER_TABS } from "./helpCenterPaths";
import { HelpMediaTab } from "./HelpMediaTab";
import { HelpSnippetsTab } from "./HelpSnippetsTab";

// Dwie listy, dwa porządki: instrukcje układa człowiek (kolejność na /pomoc),
// a „Co nowego” układa data wydania funkcji — wpis zredagowany we wrześniu
// o funkcji z czerwca ląduje w czerwcu.
const HelpCenter = () => {
  // Zakładka w adresie: powrót z edycji i przycisk „wstecz” wracają na nią,
  // zamiast zawsze na pierwszą („Instrukcje”).
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("tab");
  const activeKey = HELP_CENTER_TABS.find((tab) => tab === requested) ?? "guides";

  return (
    <Card>
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        Centrum pomocy
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        Instrukcje i wpisy „Co nowego” dla klientek. Materiał widzą dopiero po publikacji — do tego czasu zostaje
        szkicem widocznym wyłącznie tutaj.
      </Typography.Paragraph>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams({ tab: key }, { replace: true })}
        destroyOnHidden
        items={[
          { key: "guides", label: "Instrukcje", children: <HelpArticlesTab kind="guide" /> },
          { key: "updates", label: "Co nowego", children: <HelpArticlesTab kind="update" /> },
          { key: "media", label: "Media", children: <HelpMediaTab /> },
          { key: "snippets", label: "Szablony", children: <HelpSnippetsTab /> },
        ]}
      />
    </Card>
  );
};

export default HelpCenter;
